import { Accordion, AccordionSummary, Button } from '@utilisourcepackagelibdev/utilisourcepackagelib';
import { Controller, FormProvider, useForm, useFormContext } from 'react-hook-form';
import { Typography, Box, AccordionDetails, TextField, Container, useTheme, TextareaAutosize, OutlinedInput, styled } from '@mui/material';
import useTicketList from '@/contexts/stores/ticketList.store';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { timezoneOffset } from '@/util/timezoneOffset.util';
import Permissions from '@/permissions/Permissions';
import { useParams } from '@tanstack/react-router';
import utc from 'dayjs/plugin/utc';
import { useState } from 'react';
import dayjs from 'dayjs';
import { TextEditorReadOnly } from 'mui-tiptap-editor';
import { createAgentsByCustomerQueryOptions, createNotesQueryOptions } from '@/services/ticket/ticket.options';
import { useQuery } from '@tanstack/react-query';
import useTicketMutationsNotes from '@/services/ticket/ticketNotes.mutations';
import { SaveIcon, TrashIcon, XIcon } from 'lucide-react';
import useTicketTableStore from '../ticketList/useTicketTableStore.hook';

const Notes = () => {

  const theme = useTheme();
  const { ticketTableState } = useTicketTableStore()
  dayjs.extend(utc);
  const [showAddNoteButton, setShowAddNoteButton] = useState(true);
  const methods = useForm();

  const { control } = methods;

  const { ticketId } = useParams({
    from: '/_auth/ticket/$ticketId',
  })
  const ticketId2 = Number(ticketId)

  const agentsByCustomer = useQuery(createAgentsByCustomerQueryOptions(ticketTableState?.customFilters?.customer?.id, ticketId))
  const notesById = useQuery(createNotesQueryOptions(ticketId))
  const { updateTicketNotes } = useTicketMutationsNotes();

  const createNoteAccordions = () => {
    const sortedNotesWithSubjects = notesById?.data
      .filter((note: any) => note.Message)
      .sort((a: any, b: any) => new Date(b.Createtime).getTime() - new Date(a.Createtime).getTime());

    return sortedNotesWithSubjects?.map((note: any) => {
      const offsetInMinutes = timezoneOffset(note?.TimeZoneOffset);
      const localizedTime = offsetInMinutes ? dayjs.utc(note.Createtime).utcOffset(offsetInMinutes) : dayjs(note.Createtime);
      return (
        <Accordion id={note.Nid} key={note.Nid} sx={{ marginBottom: 2, borderRadius: 1, boxShadow: "rgba(50, 50, 93, 0.025) 0px 2px 5px -1px, rgba(0, 0, 0, 0.05) 0px 1px 3px 2px;", '&::before': { display: 'none' }, }}>
          <AccordionSummary
            sx={{
              '& .MuiAccordionSummary-content': {
                display: "flex",
                flexDirection: "column",
              },
              padding: '8px 16px',
            }}
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography variant="body2" >
              {note.AuthorName} {dayjs(note.Createtime).format("MM/DD/YYYY")} {localizedTime.format("hh:mm A")} {note.TimeZone}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: '16px',
            }}
          >
            {/* <Typography variant="body1"> */}
            {/* {note.Message} */}
            <TextEditorReadOnly
              value={note.Message}
            />
            {/* </Typography> */}
          </AccordionDetails>
        </Accordion>
      )
    });

  };

  const onSubmit = async () => {
    const methodValues = methods.getValues()
    setShowAddNoteButton(true);

    const preparedData = {
      "message": methodValues.note,
      "subject": "",
      "ticketid": ticketId2,
      "authorname": agentsByCustomer.data?.ContextUser?.Name
    }

    const agentName = agentsByCustomer.data


    console.log('agentName', agentName);
    console.log('preparedData', preparedData);

    try {
      if (methodValues.note) {
        await updateTicketNotes({ actionType: 'updateTicketNotes', data: preparedData });
      }
      methods.reset({ note: "" });
    } catch (error) {
      console.error("Error updating Note:", error);
    }
  }

  return (
    <>
      {showAddNoteButton &&
        <Permissions target={'ticketDetailSave'}>
          <Button id='addNoteBtn' variant='outlined' onClick={() => setShowAddNoteButton(false)} sx={{ mb: 4 }}>Add Note</Button>
        </Permissions>
      }
      <Container maxWidth="lg">
        {!showAddNoteButton &&
          <Box sx={{
            backgroundColor: theme.palette.background.paper,
            padding: 3,
            borderRadius: 2,
            mb: 4,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <FormProvider {...methods}>
              <form onSubmit={methods.handleSubmit(onSubmit)}>
                <Box component="form">
                  <Typography variant="h6" sx={{ mb: 4 }}>
                    Add New Note
                  </Typography>
                  <Controller
                    name="note"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <>
                        <TextField
                          fullWidth
                          {...field}
                          id="outlined-multiline-static"
                          label="Note"
                          multiline
                          minRows={3}
                          maxRows={6}
                          sx={{
                            mb: 4,
                            flexGrow: 1,
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                              // backgroundColor: theme.palette.background.paper
                            }
                          }}
                          placeholder="Enter your note here..."
                          autoFocus
                        />
                      </>
                    )}
                  />
                </Box>
              </form>
            </FormProvider>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'space-between' }}>
              <Button
                id='saveNoteBtn'
                variant='contained'
                onClick={methods.handleSubmit(onSubmit)}
                size='small'
                disabled={!methods.watch('note')}

              >
                Save Note
              </Button>
              <Box sx={{ display: 'flex', gap: 2 }}>

                <Button
                  id='cancelNoteBtn'
                  color='error'
                  variant='outlined'
                  onClick={() => {
                    setShowAddNoteButton(true)
                    methods.reset({ note: "" })
                  }}
                  startIcon={<XIcon />}
                  size='small'
                >
                  Cancel
                </Button>
                <Button
                  id='clearNoteBtn'
                  variant='outlined'
                  onClick={() => methods.reset({ note: "" })}
                  size='small'
                >
                  Clear
                </Button>
              </Box>

            </Box>
          </Box>
        }
      </Container>
      {notesById.data && createNoteAccordions()}
    </>
  )
}

export default Notes